import styles from './MapPage.module.css';
import { Sidebar } from '../../components/Sidebar';
import Map from '../../components/Map';
import { FilterSidebar } from '../../components/FilterSidebar';
import { SelectLanguage } from '../../components/SelectLanguage/SelectLanguage';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { requestLoggedUserInfo } from '../../ac/requestLoggedUserInfo';
import { loadRegions } from '../../ac/onChangeRegions';
import { isEmpty } from '../../utils/isEmpty';
import MenuIcon from '@material-ui/icons/Menu';
import FilterListIcon from '@material-ui/icons/FilterList';

const MapPageComponent = ({
    loggedUser,
    requestLoggedUserInfo,
    loadRegions,
    layers,
    displayedLayers = [],
}) => {
    const [ isSidebarVisible, setIsSidebarVisible ] = useState(true);
    const [ screenSize, setScreenSize ] = useState(
        window.innerWidth <= 850 ? 'mobile' : window.innerWidth < 1101 ? 'narrow' : 'desktop'
    );
    // На десктопе и мобильных правая панель скрыта по умолчанию
    const [ isFilterSidebarVisible, setIsFilterSidebarVisible ] = useState(false);
    const [ hasFilterContent, setHasFilterContent ] = useState(false);
    // Флаг для отслеживания: пользователь ли включал/выключал панель вручную
    const [ isFilterSidebarManual, setIsFilterSidebarManual ] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const newScreenSize = width <= 850 ? 'mobile' : width < 1101 ? 'narrow' : 'desktop';
            setScreenSize(newScreenSize);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // На десктопе: автоматически открываем правую панель если есть контент
    useEffect(() => {
        if (screenSize === 'mobile') return; // На мобильных не трогаем автоматику

        if (hasFilterContent) {
            // Если есть контент и пользователь не закрыл панель вручную - показываем
            if (!isFilterSidebarManual) {
                setIsFilterSidebarVisible(true);
            }
        } else {
            // Если нет контента - закрываем и сбрасываем флаг
            setIsFilterSidebarVisible(false);
            setIsFilterSidebarManual(false);
        }
    }, [ screenSize, hasFilterContent, isFilterSidebarManual ]);

    const closeAllPanels = () => {
        setIsSidebarVisible(false);
        setIsFilterSidebarVisible(false);
        setIsFilterSidebarManual(false);
    };
    const toggleSidebar = () => {
        setIsSidebarVisible(prevState => {
            const newState = !prevState;
            // Только на мобильных: если открываем левую панель, закрываем правую
            if (newState && screenSize === 'mobile') {
                setIsFilterSidebarVisible(false);
            }
            return newState;
        });
    };
    const toggleFilterSidebar = () => {
        setIsFilterSidebarVisible(prevState => {
            const newState = !prevState;
            // Отмечаем, что это ручное управление
            setIsFilterSidebarManual(true);
            // Только на мобильных: если открываем правую панель, закрываем левую
            if (newState && screenSize === 'mobile') {
                setIsSidebarVisible(false);
            }
            return newState;
        });
    };
    const handleFilterContentChange = content => {
        setHasFilterContent(content);
    };

    useEffect(requestLoggedUserInfo, [ requestLoggedUserInfo ]);
    useEffect(() => {
        loadRegions();
    }, [ loadRegions ]);

    if (isEmpty(loggedUser) || !layers.length) return null;

    return (
        <div className={styles.mapPageContainer}>
            <header className={styles.pageHeader}>
                <div
                    className={styles.toggleIcon}
                    onClick={toggleSidebar}
                    title="Toggle sidebar"
                >
                    <MenuIcon style={{ color: '#fff', width: 24, height: 24 }} />
                </div>
                <span className={styles.whooshText}>Whoosh</span>
                <div className={styles.selectLanguage}>
                    <SelectLanguage />
                </div>
                <div
                    className={styles.filterIcon}
                    onClick={toggleFilterSidebar}
                    title="Toggle filters"
                >
                    <FilterListIcon style={{ color: '#fff', width: 24, height: 24 }} />
                </div>
            </header>
            <Sidebar isVisible={isSidebarVisible} />
            <Map
                isFilterSidebarVisible={isFilterSidebarVisible}
                isSidebarVisible={isSidebarVisible}
            />
            <FilterSidebar
                isVisible={isFilterSidebarVisible}
                onContentChange={handleFilterContentChange}
                hasContent={hasFilterContent}
            />
            {/* Overlay для закрытия панелей на мобильных при клике на карту */}
            {screenSize === 'mobile' && (isSidebarVisible || isFilterSidebarVisible) && (
                <div
                    className={styles.panelsOverlay}
                    onClick={closeAllPanels}
                />
            )}
        </div>
    );
};
const mapStateToProps = ({ loggedUser, map: { layers, displayedLayers } }) => ({ loggedUser, layers, displayedLayers });
export const MapPage = connect(mapStateToProps, { requestLoggedUserInfo, loadRegions })(MapPageComponent);
